module.exports = __webpack_public_path__ + "static/media/business-Insider-Logo.094c6a31.png";